import { getUrlCourtCode } from "./Court";
import { getCourtPlace } from "./LocalStorage";

export function checkIsSAdmin() {
    let admin = localStorage.getItem('user_info')
    admin = admin ? JSON.parse(admin) : null
    return admin?.role === 'superadmin'
}

export const isMerchant = (showMenu = false) => {
    const raw = localStorage.getItem('user_info');
    const userInfo = raw ? JSON.parse(raw) : null;

    if (userInfo?.merchantId) {
        return userInfo?.merchantId
    } else if (showMenu) {
        return ''
    } else {
        getUrlCourtCode()
        return getCourtPlace().merchantId || ''
    }
}

export const isSTCAdmin = () => {
    const raw = localStorage.getItem('user_info');
    const userInfo = raw ? JSON.parse(raw) : null;
    console.log("here userInfo", userInfo)
    if (userInfo?.merchantId) {
        return false
    } else {
        return true
    }
}